/* NovaHair live beacon.
 *
 * Reports what a shopper does on a sales page to the Worker as it happens, so the
 * Live screen in Funnel Control can show it seconds later. Only actions on the page:
 * no names, no emails, no typed text. Batched every two seconds, one request per
 * batch, sent through the Shopify app proxy which signs every request.
 *
 * Loaded by the sales page layout after the page's own scripts. ES5 on purpose.
 */
(function (global) {
  'use strict';
  var doc = document;
  var PAGE = global.location.pathname;
  if (!/^\/pages\//.test(PAGE)) return;

  var ENDPOINT = '/apps/funnels/live';
  var FLUSH_MS = 2000, MAX_BATCH = 20, MAX_PER_LOAD = 80;
  var queue = [], timer = null, sent = 0, started = Date.now();

  function rand() { return 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12); }
  function stored(store, name) {
    try { var v = store.getItem(name); if (!v) { v = rand(); store.setItem(name, v); } return v; } catch (_) { return rand(); }
  }
  function cookie(name) { var m = doc.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)')); return m ? decodeURIComponent(m[1]) : ''; }
  function text(el, max) { return String((el && (el.getAttribute('aria-label') || el.getAttribute('data-label') || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, max || 60); }

  var sessionKey = stored(global.sessionStorage, 'nh_live_session');
  var visitorKey = (cookie('_fc_visitor').match(/^[A-Za-z0-9_-]{8,120}$/) || [])[0] || stored(global.localStorage, 'nh_live_visitor');

  /* The checkout pixel reads the _funnel_context cookie the attribution script keeps,
     and only carries a visitorId if something put one there. Nothing did on this page,
     so nine checkouts in ten reached the app with no person behind them. Put this
     page's key in; the attribution script keeps whatever visitorId it finds. */
  (function shareVisitorKey() {
    try {
      var raw = cookie('_funnel_context');
      var ctx = raw ? JSON.parse(raw) : {};
      if (!ctx || typeof ctx !== 'object' || Array.isArray(ctx)) ctx = {};
      if (ctx.visitorId === visitorKey) return;
      if (ctx.visitorId && /^[A-Za-z0-9_-]{8,180}$/.test(ctx.visitorId)) { visitorKey = ctx.visitorId; return; }
      ctx.visitorId = visitorKey;
      doc.cookie = '_funnel_context=' + encodeURIComponent(JSON.stringify(ctx)) + '; Path=/; Max-Age=2592000; SameSite=Lax; Secure';
    } catch (_) {}
  })();

  var params; try { params = new URLSearchParams(global.location.search); } catch (_) { params = { get: function () { return null; } }; }
  function sourceLabel() {
    try {
      var saved = global.sessionStorage.getItem('nh_live_source');
      if (saved) return saved;
    } catch (_) {}
    var utm = params.get('utm_source'), medium = params.get('utm_medium'), campaign = params.get('utm_campaign');
    var ref = ''; try { ref = doc.referrer ? new URL(doc.referrer).hostname.replace(/^www\./, '') : ''; } catch (_) {}
    var label = utm ? utm + (medium ? ' / ' + medium : '') + (campaign ? ' / ' + campaign.slice(0, 40) : '') : (ref || 'direct');
    if (/fbclid/.test(global.location.search) && !utm) label = 'facebook / paid';
    try { global.sessionStorage.setItem('nh_live_source', label); } catch (_) {}
    return label.slice(0, 80);
  }
  var source = sourceLabel();
  var isInternal = (function () {
    var flag = params.get('fc_internal') === '1' || params.get('tbg_qa') === '1' || Boolean(params.get('nova_cro_variant')) || /(?:^|; )_tbg_analytics_exclude=1/.test(doc.cookie);
    try { if (flag) global.sessionStorage.setItem('nh_live_internal', '1'); else if (global.sessionStorage.getItem('nh_live_internal') === '1') flag = true; } catch (_) {}
    return flag;
  })();
  var device = (function () {
    var ua = navigator.userAgent || '';
    var app = /FBAN|FBAV|FB_IAB/i.test(ua) ? '-facebook' : /Instagram/i.test(ua) ? '-instagram' : '';
    return (/iPhone|iPad/i.test(ua) ? 'iphone' : /Android/i.test(ua) ? 'android' : /Mobile/i.test(ua) ? 'mobile' : 'desktop') + app;
  })();

  function variant() { return doc.documentElement.getAttribute('data-nova-cro') || null; }
  /* Other tests the page runs, written by their own scripts (the exit popup's offer test). */
  function experiments() {
    try {
      var parsed = JSON.parse(global.localStorage.getItem('nh_experiments') || 'null');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (_) { return {}; }
  }
  function payload(events) {
    return JSON.stringify({ sessionKey: sessionKey, visitorKey: visitorKey, page: PAGE, device: device, source: source, variant: variant(), experiments: experiments(), isInternal: isInternal, events: events });
  }
  function flush(unloading) {
    if (timer) { global.clearTimeout(timer); timer = null; }
    if (!queue.length) return;
    var batch = queue.splice(0, MAX_BATCH);
    var body = payload(batch);
    try {
      if (unloading && navigator.sendBeacon) {
        if (navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
      }
      global.fetch(ENDPOINT, { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body }).catch(function () {});
    } catch (_) {}
    if (queue.length) schedule();
  }
  function schedule() { if (!timer) timer = global.setTimeout(function () { flush(false); }, FLUSH_MS); }
  function push(kind, label, detail) {
    if (sent >= MAX_PER_LOAD) return;
    sent += 1;
    queue.push({ kind: kind, label: label, detail: detail || {}, at: Date.now() });
    if (queue.length >= MAX_BATCH) flush(false); else schedule();
  }

  /* ---- what we watch ---- */
  var UA = navigator.userAgent || '';
  var APP = /FBAN|FBAV|FB_IAB/.test(UA) ? 'facebook' : /Instagram/.test(UA) ? 'instagram' : 'browser';
  var OSV = (function () { var m = UA.match(/OS (\d+)_(\d+)/) || UA.match(/Android (\d+)/); return m ? (m[2] ? m[1] + '.' + m[2] : m[1]) : ''; })();
  push('view', 'landed', { referrer: source, width: global.innerWidth, variant: variant(), height: global.innerHeight, app: APP, os: OSV, shown: doc.visibilityState });

  var seenSections = {};
  var SECTION_LABELS = { buy: 'reached the buy box', 'proof-bar': 'passed the trust bar', 'before-after': 'looked at before / after', mechanism: 'reading how it works', formula: 'reading ingredients', 'how-to-use': 'reading how to use', 'social-proof': 'reading reviews', comparison: 'reading the comparison', 'offer-reentry': 'saw the offer again', guarantee: 'reading the guarantee', faq: 'reading the FAQ', 'reviews-full': 'reading all reviews' };
  if (global.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id; if (!id || seenSections[id]) return;
        seenSections[id] = true;
        push('section', SECTION_LABELS[id] || ('reached ' + id), { id: id });
      });
    }, { threshold: 0.4 });
    var sections = doc.querySelectorAll('section[id]');
    for (var i = 0; i < sections.length; i++) io.observe(sections[i]);
  }

  var lastDepth = 0;
  global.addEventListener('scroll', function () {
    var height = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight) - global.innerHeight;
    if (height <= 0) return;
    var depth = Math.floor(((global.scrollY || global.pageYOffset || 0) / height) * 4) * 25;
    if (depth > lastDepth) { lastDepth = depth; if (depth >= 25) push('section', 'scrolled ' + depth + '%', { depth: depth }); }
  }, { passive: true });

  doc.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var t = event.target; if (!t || !t.closest) return;
    var bundle = t.closest('.bundle-card');
    if (bundle) { var qty = bundle.getAttribute('data-nova-bundle') || (bundle.getAttribute('data-offer') || '').replace('pack', ''); push('bundle', 'chose ' + qty + ' bottles (₪' + (bundle.getAttribute('data-price') || '') + ')', { bundle: qty, price: bundle.getAttribute('data-price') }); return; }
    var shade = t.closest('.nh-shade-option-v2, .shade-option');
    if (shade) { var key = shade.getAttribute('data-nova-shade') || shade.getAttribute('data-color'); push('shade', 'picked shade ' + text(shade, 30), { shade: key }); return; }
    if (t.closest('[data-nova-action="shade-compare"], .nh-shade-compare-trigger-v2')) { push('compare', 'opened the shade comparison'); return; }
    if (t.closest('.mix-shades-btn')) { push('mix', 'opened mix shades'); return; }
    if (t.closest('.nh-cro-vd__cta')) { push('module_action', 'took the upgrade to 4 bottles', { module: 'value_delta' }); return; }
    if (t.closest('.nh-cro-vd__decline')) { push('module_action', 'declined the upgrade', { module: 'value_delta' }); return; }
    if (t.closest('.nh-cro-cart__cta')) { push('module_action', 'took the upgrade in the cart', { module: 'value_delta' }); return; }
    if (t.closest('.nh-cro-sr__cta, .nh-cro-sr__help')) { push('module_action', 'used shade help', { module: 'shade_rescue' }); return; }
    if (t.closest('.nh-cro-sc__cta')) { push('module_action', 'took the scroll shortcut', { module: 'scroll_rescue' }); return; }
    if (t.closest('#CartDrawer-Checkout, cart-drawer [name="checkout"]')) { push('checkout_click', 'went to checkout'); return; }
    if (t.closest('#mainCheckout, #stickyCtaBtn, [data-nova-action="add-to-cart"]')) { push('click', 'tapped the buy button: ' + text(t.closest('button'), 40)); return; }
    if (t.closest('.nh-exit-popup, .nh-exit-popup__dialog')) { push('popup', 'exit popup: ' + text(t.closest('button, a') || t, 40)); return; }
    if (t.closest('[data-return-to-buybox], .nh-midpage-cta__button')) { push('click', 'tapped a mid-page button'); return; }
    var faq = t.closest('.faq-item__trigger, .faq-item summary, [data-faq-trigger]');
    if (faq) { push('faq', 'opened a question: ' + text(faq, 70).replace(/\s*\+$/, ''), { question: text(faq, 90) }); return; }
    var thumb = t.closest('.thumb, [data-media-id], .gallery-thumb, .ugc-gallery__item');
    if (thumb) { push('gallery', 'looked at a gallery photo', { media: thumb.getAttribute('data-media-id') || null }); return; }
    if (t.closest('.ugc-review-card, #ugcModalCta, .reviews-summary, [data-review-id], .reviews-insights')) { push('reviews', 'read the reviews', {}); return; }
    if (t.closest('[data-popup-code], .nh-exit-popup__code, [data-copy-code]')) { push('popup', 'copied the discount code'); return; }
    var control = t.closest('a, button, [role="button"], summary, .thumb');
    if (control) push('click', 'tapped ' + (control.tagName === 'A' ? 'link' : 'button') + (text(control, 40) ? ': ' + text(control, 40) : ''), { tag: control.tagName.toLowerCase(), id: control.id || null });
  }, true);

  doc.addEventListener('sales-page-commerce:added', function (event) {
    var sel = doc.querySelector('.bundle-card.sel');
    var qty = sel ? (sel.getAttribute('data-nova-bundle') || (sel.getAttribute('data-offer') || '').replace('pack', '')) : '';
    var detail = (event && event.detail) || {};
    push('cart_add', 'added ' + (qty ? qty + ' bottles' : 'the bundle') + ' to cart' + (detail.alreadyPresent ? ' (already there)' : ''), { bundle: qty, variantId: detail.variantId || null });
    flush(false);
  });
  var drawer = doc.querySelector('cart-drawer');
  if (drawer && global.MutationObserver) {
    var open = drawer.classList.contains('active');
    new MutationObserver(function () {
      var now = drawer.classList.contains('active');
      if (now !== open) { open = now; push(now ? 'cart_open' : 'cart_close', now ? 'opened the cart' : 'closed the cart'); }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  var MODULE_LABELS = { nova_cro_module_viewed: 'saw', nova_cro_triggered: 'qualified for', nova_value_delta_upgrade: 'upgraded via', nova_value_delta_decline: 'declined' };
  doc.addEventListener('nova-cro:event', function (event) {
    var d = (event && event.detail) || {}; var props = d.props || {};
    if (d.name === 'nova_cro_module_viewed') push('module', 'saw ' + String(props.module || '').replace(/_/g, ' ') + (props.placement ? ' (' + props.placement.replace(/_/g, ' ') + ')' : ''), { module: props.module, placement: props.placement || null });
    else if (d.name === 'nova_cro_triggered') push('module', 'qualified for ' + String(props.module || '').replace(/_/g, ' ') + ' (' + String(props.reason || '').replace(/_/g, ' ') + ')', { module: props.module, reason: props.reason || null, viewed: false });
  });

  /* The popup engine, the concierge and the cart scripts report to PostHog. Mirror
     the ones a person would want to see in the feed, straight from the call, so
     the feed shows them within seconds and even for shoppers who never accepted
     cookies (PostHog drops those; the call is still made). */
  var MIRROR = {
    popup_signal: ['signal', function (p) { return 'exit signal: ' + String(p.signal || p.trigger || p.reason || 'seen').replace(/_/g, ' '); }],
    popup_eligible: ['signal', function () { return 'became eligible for the exit popup'; }],
    popup_suppressed: ['signal', function (p) { return 'popup held back (' + String(p.reason || 'rule').replace(/_/g, ' ') + ')'; }],
    popup_view: ['popup', function () { return 'saw the exit popup'; }],
    popup_closed: ['popup', function () { return 'closed the exit popup'; }],
    popup_continue_clicked: ['popup', function () { return 'continued from the popup'; }],
    popup_email_started: ['popup', function () { return 'started typing an email in the popup'; }],
    popup_submit_success: ['popup', function () { return 'left an email in the popup'; }],
    popup_ai_step: ['concierge', function (p) { return 'concierge: ' + String(p.step || p.stage || p.lane || p.agent || 'step').replace(/_/g, ' '); }],
    bump_added: ['cart_change', function (p) { return 'added the cart bump' + (p.title || p.product ? ': ' + String(p.title || p.product).slice(0, 40) : ''); }],
    cart_item_removed: ['cart_change', function () { return 'removed an item from the cart'; }],
    shade_required_prompt_shown: ['shade', function () { return 'was asked to pick a shade first'; }],
    shade_mix_completed: ['mix', function () { return 'mixed shades in the pack'; }],
    shade_compare_continued: ['compare', function () { return 'chose a shade from the comparison'; }],
    add_to_cart_attempted: ['click', function () { return 'tried to add to cart'; }],
    exit_offer_viewed: ['popup', function () { return 'saw the exit offer'; }],
    exit_offer_submitted: ['popup', function () { return 'took the exit offer'; }],
    exit_offer_dismissed: ['popup', function () { return 'dismissed the exit offer'; }]
  };
  var mirrored = 0;
  function mirror(name, props) {
    var spec = MIRROR[name];
    if (!spec || mirrored >= 60) return;
    mirrored += 1;
    var p = props && typeof props === 'object' ? props : {};
    push(spec[0], String(spec[1](p)).slice(0, 120), { event: name });
  }
  (function wrapPostHog(tries) {
    var ph = global.posthog;
    if (ph && ph.__loaded && typeof ph.capture === 'function' && !ph.__nhLiveMirror) {
      var original = ph.capture;
      ph.capture = function (name, props) { try { mirror(name, props); } catch (_) {} return original.apply(this, arguments); };
      ph.__nhLiveMirror = true;
      return;
    }
    if (tries < 40) global.setTimeout(function () { wrapPostHog(tries + 1); }, 500);
  })(0);

  /* Meta's ids (nova_fbp, nova_fbc) and this visitor key reach the cart from tbg-meta-signals.js since
     25.10.2026, on every page, and a write counts only when Shopify keeps it. This file used to write them
     and marked a refused write as saved. */

  function leave() {
    push('leave', 'left after ' + Math.round((Date.now() - started) / 1000) + 's', { seconds: Math.round((Date.now() - started) / 1000), depth: lastDepth });
    flush(true);
  }
  global.addEventListener('pagehide', leave);
  doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') flush(true); });

  /* Real phones, real numbers (2.11.2026). Load timing and page errors from shoppers' own browsers, split by
     iPhone/Android, iOS version and the app that opened the page (Facebook, Instagram, browser), so an
     iPhone-only failure shows in data instead of waiting for a lab to find it. Sent through the analytics
     shim to AnalyticsEvent as page_timing and page_js_error (QA visits are excluded there). Errors from the
     page's first line are caught by the layout into window.__nhErr. */
  (function realUserNumbers() {
    try {
      var base = { page: PAGE, os: /iPhone|iPad/.test(UA) ? 'ios' : /Android/.test(UA) ? 'android' : 'other', osv: OSV, app: APP, w: global.innerWidth, h: global.innerHeight, dpr: global.devicePixelRatio || 1, cro: variant() || '' };
      var send = function (name, extra) {
        try {
          var p = {}, k;
          for (k in base) p[k] = base[k];
          for (k in extra) p[k] = extra[k];
          if (global.posthog && typeof global.posthog.capture === 'function') global.posthog.capture(name, p, { transport: 'sendBeacon' });
        } catch (_) {}
      };
      var lcp = 0, shownAtStart = doc.visibilityState === 'visible', timed = false;
      try { new PerformanceObserver(function (list) { var e = list.getEntries(); if (e.length) lcp = Math.round(e[e.length - 1].startTime); }).observe({ type: 'largest-contentful-paint', buffered: true }); } catch (_) {}
      var timing = function (reason) {
        if (timed) return;
        timed = true;
        var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
        var fcp = 0;
        try { var paints = performance.getEntriesByType('paint'); for (var i = 0; i < paints.length; i++) if (paints[i].name === 'first-contentful-paint') fcp = Math.round(paints[i].startTime); } catch (_) {}
        var hero = doc.getElementById('galMain');
        send('page_timing', { reason: reason, ttfb: Math.round(nav.responseStart || 0), fcp: fcp, lcp: lcp, dcl: Math.round(nav.domContentLoadedEventEnd || 0), load: Math.round(nav.loadEventEnd || 0), kb: Math.round((nav.transferSize || 0) / 1024), hero: hero ? (hero.complete && hero.naturalWidth > 0) : null, shown: shownAtStart, conn: (navigator.connection && navigator.connection.effectiveType) || '' });
      };
      if (doc.readyState === 'complete') global.setTimeout(function () { timing('load'); }, 3000);
      else global.addEventListener('load', function () { global.setTimeout(function () { timing('load'); }, 3000); });
      doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') timing('hidden'); });
      global.addEventListener('pagehide', function () { timing('pagehide'); });
      var errorsSent = 0;
      var flushErrors = function () { var list = global.__nhErr || []; while (list.length && errorsSent < 6) { errorsSent += 1; send('page_js_error', list.shift()); } };
      flushErrors();
      global.setTimeout(flushErrors, 8000);
      global.addEventListener('error', function () { global.setTimeout(flushErrors, 0); }, true);
      global.addEventListener('unhandledrejection', function () { global.setTimeout(flushErrors, 0); });

      /* Dead taps: a finger lifted on a shade, a pack or a buy button with no click after it. iPhone cancels or
         swallows a tap when the page moves under the finger, and then nothing happens for her. Counted per
         phone as page_dead_tap (at most 5 a page). Clicks are watched on window so a handler that stops the
         click further down cannot hide it. */
      var KEY = '.nh-shade-option-v2, .shade-option, .bundle-card, #mainCheckout, #stickyCtaBtn';
      var pending = null, deadSent = 0;
      var what = function (el) { return el.id || (el.classList.contains('bundle-card') ? 'pack' : 'shade'); };
      var report = function (kind) {
        if (!pending || deadSent >= 5) { pending = null; return; }
        deadSent += 1;
        var box = pending.el.getBoundingClientRect();
        send('page_dead_tap', { kind: kind, what: what(pending.el), held: Date.now() - pending.at, pageMoved: Math.abs((global.scrollY || 0) - pending.y0) > 2, top: Math.round(box.top) });
        pending = null;
      };
      doc.addEventListener('touchstart', function (e) {
        var el = e.target && e.target.closest ? e.target.closest(KEY) : null;
        var p = e.touches && e.touches[0];
        pending = el && p && e.touches.length === 1 ? { el: el, x: p.clientX, y: p.clientY, at: Date.now(), y0: global.scrollY || 0, moved: false } : null;
      }, { capture: true, passive: true });
      doc.addEventListener('touchmove', function (e) {
        var p = e.touches && e.touches[0];
        if (pending && p && (Math.abs(p.clientX - pending.x) > 10 || Math.abs(p.clientY - pending.y) > 10)) pending.moved = true;
      }, { capture: true, passive: true });
      doc.addEventListener('touchcancel', function () { if (pending && !pending.moved) report('cancel'); pending = null; }, { capture: true, passive: true });
      doc.addEventListener('touchend', function () {
        if (!pending || pending.moved) { pending = null; return; }
        var mine = pending;
        global.setTimeout(function () { if (pending === mine) report('no-click'); }, 700);
      }, { capture: true, passive: true });
      global.addEventListener('click', function (e) { if (pending && e.target && (pending.el === e.target || pending.el.contains(e.target))) pending = null; }, true);
    } catch (_) {}
  })();
})(window);
